export default "__VITE_ASSET__dcNCLdXT__"